import React, { FC } from 'react';
import { Radio, RadioGroupProps } from 'antd';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './BooleanRadio.translations.json';

const { addTranslations, useTranslation } = i18nNsFactory('boolean-radio');
addTranslations(translations);

export interface BooleanRadio extends RadioGroupProps {
  id: string;
}

export const BooleanRadio: FC<BooleanRadio> = (props) => {
  const { id, ...rest } = props;
  const { t } = useTranslation();

  return (
    <Radio.Group id={id} {...rest}>
      <Radio id={`${id}-all`} value={''}>
        {t(`all`)}
      </Radio>
      <Radio id={`${id}-yes`} value={true}>
        {t(`yes`)}
      </Radio>
      <Radio id={`${id}-no`} value={false}>
        {t(`no`)}
      </Radio>
    </Radio.Group>
  );
};
